import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { APIService } from '@app/_services/api.service';
import { ResponseCurrency } from '@app/_interfaces/responses';
import { API_PATH } from '@app/app.constants';

@Injectable({
    providedIn: 'root'
})
export class AccountService {
    constructor(private api: APIService) {}

    getCurrentCurrency(): Observable<ResponseCurrency> {
        return this.api.get(API_PATH.accounts.current_currency);
    }

    getLessonCurrency(lessonId: number): Observable<ResponseCurrency> {
        const url = `${API_PATH.accounts.lesson_currency}/${lessonId}`;
        return this.api.get(url);
    }
}
